import Image from 'next/image'
import aratLogo from './arat.png'

type IconProps = {
  className?: string
}

const ARATLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={aratLogo} alt="ARAT Logo" height={48} {...attributes} />
}

export default ARATLogo
